/* eslint-disable react/prop-types */
import React from 'react'
import styled, { css } from 'styled-components'
import shortid from 'shortid'
import orderBy from 'lodash/orderBy'
import { SPACING as constants } from '../../constants'

import moment from '../../lib/moment'
import Arrow from '../../lib/components/Arrow'
import { createTable } from '../../lib/components/Table'

// prettier-ignore
const BaseTable = createTable(css`
  grid-template-columns:
    150px
    160px
    140px
    170px
    minmax(250px, 1fr);

  justify-content: center;

  > :first-child {
    padding-left: ${constants.GAP};
  }

  > :last-child {
    padding-right: ${constants.GAP};
  }
`)

const Table = {
  ...BaseTable,
  RowCell: styled(BaseTable.RowCell)`
    padding-top: 0;
    padding-bottom: 0;
  `,
}

const Layout = {
  ScrollWrapper: styled.div`
    /* tab bar + margin + table header */
    height: calc(100% - (50px + 10px));
    overflow-y: scroll;
  `,
  Truncate: styled.div`
    max-height: 100%;
    overflow: hidden;

    // ! non-standard
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  `,
}

/**
 * @param {object} props
 * @param {Array} props.data
 * @param {(target: string) => () => void} props.rowClick
 * @param {(idx: number) => () => void} props.colClick
 */
function ImportListTable({ data = [], rowClick = () => {}, colClick = () => {}, ...other }) {
  const { sort } = other

  const arrow = col => {
    if (col === sort.column) {
      if (sort.order) return <Arrow direction="down" />
      return <Arrow direction="up" />
    }
    return null
  }

  const sortData = () => {
    const order = [
      data => moment(data.date, 'DD/MM/YYYY'),
      'transaction_amount',
      'project_amount',
      'imported_by',
      'remark',
    ]
    return orderBy(data, order[sort.column], sort.order ? 'asc' : 'desc')
  }

  return (
    <React.Fragment>
      <Layout.ScrollWrapper>
        <Table.Head>
          <Table.HeadCell onClick={ colClick(0) }>
            Import Date
            {arrow(0)}
          </Table.HeadCell>
          <Table.HeadCell onClick={ colClick(1) }>
            Transaction Amount
            {arrow(1)}
          </Table.HeadCell>
          <Table.HeadCell onClick={ colClick(2) }>
            Projects Amount
            {arrow(2)}
          </Table.HeadCell>
          <Table.HeadCell onClick={ colClick(3) }>
            Imported By
            {arrow(3)}
          </Table.HeadCell>
          <Table.HeadCell onClick={ colClick(4) }>
            Remark
            {arrow(4)}
          </Table.HeadCell>
        </Table.Head>
        {sortData().map(row => (
          <Table.Row key={ shortid.generate() } onClick={ rowClick(row.project_profit_accounting_id) }>
            <Table.RowCell>{row.date}</Table.RowCell>
            <Table.RowCell>{row.transaction_amount}</Table.RowCell>
            <Table.RowCell>{row.project_amount}</Table.RowCell>
            <Table.RowCell>{row.imported_by}</Table.RowCell>
            <Table.RowCell>
              <Layout.Truncate>{row.remark}</Layout.Truncate>
            </Table.RowCell>
          </Table.Row>
        ))}
      </Layout.ScrollWrapper>
    </React.Fragment>
  )
}

export default ImportListTable



// WEBPACK FOOTER //
// ./src/components/project-profit-sheet/ImportListTable.jsx